import React from 'react';

const SquareButton = ({ icon, onClick }) => (
    <button style={styles.btn} onClick={onClick}>
        <i class={icon}></i>
    </button>
);

const styles = {
    btn: {
        padding: 0,
        width: '70px',
        height: '70px',
        minWidth: '70px',
        minHeight: '70px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
};

export default SquareButton;